<template>
  <div class="supplier-edit">

    <div>
      <span v-if="isNew">新規登録</span>
      <span v-else>「{{supplier.name}}」の編集</span>      
    </div>

    <span v-if="isSystemLinked" class="pl-3 text-caption blue--text">販売管理システムと連携されているため、一部の項目は編集できません。</span>

    <!-- {{ selectedTab }} -->


    <progress-view :loading="isLoading"></progress-view>

    <div v-if="!isLoading">

      <v-tabs v-model="selectedTab">
        <v-tabs-slider></v-tabs-slider>
        <v-tab :key="1">基本</v-tab>
        <v-tab :key="2">工程</v-tab>
        <!--<v-tab :key="3">評価</v-tab>-->
        <v-tab :key="4">写真</v-tab>
      </v-tabs>
      <div v-if="selectedTab === 0">
        <SupplierEditBasic
            :value="supplier"
            v-on:cng-name="supplier.name = $event"
            v-on:cng-system_cd="supplier.systemCd = $event"
            v-on:cng-address1="supplier.address1 = $event"
            v-on:cng-address2="supplier.address2 = $event"
            v-on:cng-address3="supplier.address3 = $event"
            v-on:cng-tel="supplier.tel = $event"
            v-on:cng-fax="supplier.fax = $event"
            v-on:cng-url="supplier.url = $event"
            v-on:cng-area_cd="supplier.areaCd = $event"
            v-on:cng-president="supplier.president = $event"
            v-on:cng-capital="supplier.capital = $event"
            v-on:cng-employee_num="supplier.employeeNum = $event"
            v-on:cng-applications="supplier.applications = $event"
            v-on:cng-contractors="supplier.contractors = $event"
            v-on:cng-main_photo_id="supplier.mainPhotoId = $event"
            v-on:cng-total_sales="supplier.totalSales = $event"
            v-on:cng-my_sales="supplier.mySales = $event"
            v-on:cng-equipments="supplier.equipments = $event"
            v-on:cng-item_groups="supplier.itemGroups = $event"
        ></SupplierEditBasic>

      </div>
      <div v-if="selectedTab === 1">
        <SupplierEditProcess :process_groups="supplier.processGroups" v-on:cng-process="onChangeProcess"></SupplierEditProcess>
      </div>
      <!--
        <div v-if="selectedTab === 2">
            <SupplierEditScore></SupplierEditScore>
        </div>
        -->
      <div v-if="selectedTab === 2">
        <SupplierEditPhotos
            :cat1="supplier.imageMap.cat1"
            :cat2="supplier.imageMap.cat2"
            :cat3="supplier.imageMap.cat3"
            v-on:cng-cat1="supplier.imageMap.cat1 = $event"
            v-on:cng-cat2="supplier.imageMap.cat2 = $event"
            v-on:cng-cat3="supplier.imageMap.cat3 = $event"
            v-on:delete="onDeleteImage"
        ></SupplierEditPhotos>
      </div>

      <v-container>
        <v-row>
          <div></div>
          <v-spacer></v-spacer>
          <div class="pr-3">
            <v-btn class="mr-3" color="primary" v-on:click="onSaveClick">保存</v-btn>
            <v-btn v-on:click="onCancelClick">キャンセル</v-btn>
          </div>
        </v-row>
      </v-container>
    </div>


  </div>
</template>
<script>
import ObjectParamSupport from "../../components/ObjectParamSupport";
import BaseView from "../../components/BaseView";
import SupplierEditBasic from "./SupplierEditBasic";
import SupplierEditProcess from "./SupplierEditProcess";
import SupplierEditPhotos from "./SupplierEditPhotos";
import SupplierAPI from "@/apis/SupplierAPI";
import SupplierModel from "@/views/supplier/model/SupplierModel";

export default {
  mixins: [BaseView, ObjectParamSupport,SupplierModel],
  components: {
    SupplierEditBasic, SupplierEditProcess, SupplierEditPhotos
  },
  props: {
    sup_cd:{
      type:[String, Number]
    }
  },
  data: () => ({
    isInitialized: false,
    isFetched: false,
    isLoading: false,
    isDownloading: false,

    selectedTab: 0,

    condition: {},

    pager: {},
    errors: {},
  }),
  computed: {
    supplierId: function () {
      let supplierId = 0
      if (!!this.sup_cd && this.sup_cd !== "new") {
        supplierId = parseInt(this.sup_cd);
      }
      return supplierId
    },
    isNew: function () {
      return this.supplierId === 0
    },
    isSystemLinked(){
      return !!this.supplier.systemCd && (this.supplierId > 0);
    },
  },
  mounted: function () {
    this.setupConditions();
  },
  created: function () {
  },
  watch: {
    '$route': function (to, from) {
      this.setupConditions();
    },
  },
  methods: {
    setupConditions() {
      let p = this.getObjectParam();
      if (p) {
        // パラメータの転写
      }

      this.fetchData(true);
    },

    fetchData(needDataFetch) {
      let self = this;
      if (!this.isInitialized) {
        this.fetchBasicData(function () {
          self.fetchData(needDataFetch)
        });
        return;
      }
      if (needDataFetch) {
        if (this.isNew) {
          this.makeNewData();
        } else {
          this.isLoading = true;
          Promise.resolve()
              .then(data => SupplierAPI.get(this.supplierId))
              .then(data => this.makeDisplayData(data))              
              .catch(function (err) {
                console.log(err);
                self.showErrorToast("データの取得に失敗しました。");
              })
              .finally(function() { 
                self.isLoading = false;
              });
        }
      }
    },

    fetchBasicData(finishProc) {
      this.isInitialized = true;
      if (finishProc) {
        finishProc();
      }
    },

    onCancelClick() {
      let supId = this.supplierId;
      if (supId){
        this.$router.push({ name: 'supplier', params: { sup_cd: supId } });
      } else {
        this.$router.push({ name: 'home', params: { } })
      }      
    },

    onSaveClick() {
      let self = this

      let updateData = this.supplier;

      
      updateData.images = [].concat(
          this.supplier.imageMap.cat1,
          this.supplier.imageMap.cat2,
          this.supplier.imageMap.cat3);


      let supplierId = this.supplierId
      let isNew = supplierId === 0

      
      console.log("updatePostData",updateData)

      Promise.resolve()
          .then(a => {
            if (isNew) {
              return SupplierAPI.new(updateData)
            } else {
              return SupplierAPI.update(supplierId, updateData)
            }
          })
          .then(res => {
            // 画面を閉じる？
            console.log(res)
            self.showMessageToast("更新しました。")
            self.moveToSupplierPage();
          })
          .catch(function (err) {
            window.logger.error(err)
            self.showErrorToast("データの更新に失敗しました。");
          })
          .finally(() => {

          })

    },

    createUpdateData(){
      
      let sup = this.supplier;

      let supplierId = this.supplierId
      let isNew = supplierId === 0

      let updateData = {
        id:supplierId,
        name: sup.name,
        sname:sup.sname,
        kana:sup.kana,
        systemCd:sup.systemCd,
        areaCd: sup.areaCd,
        tel: sup.tel,        
        fax: sup.fax,
        address1: sup.address1,
        address2: sup.address2,
        address3: sup.address3,
        president: sup.president,
        url: sup.url,
        capital: sup.capital,
        mySales: sup.mySales,
        totalSales: sup.totalSales,
        salesShare:sup.salesShare,
        employeeNum: sup.employeeNum,        
        equipments:[],
        itemGroups:[],
        mainPhotoId: sup.mainPhotoId,
        applications:[],
        representatives: [],
        subSuppliers: [],
        clients: [],
        contractors: [],
        priority: sup.priority,
        remarks:sup.remarks,

        processGroups: [
          {
            processGroupCd: "",
            processGroupName: "",
            availableSizes: [
              {
                sizeItemCd: "",
                sizeItemName: "",
                unit: "",
                useRange: false,
                value1: null,
                value2: null,
              }
            ],
            materials: [
              {
                materialCd: "",
                materialName: ""
              }
            ],            
            processes:[
              {
                processCd:"",                
                processName:"",
              }
            ],
            tags: [
              ""
            ],

            materialFaces: [
              {                
                materialFaceCd: "",
                materialFaceName: ""
              }
            ],
            
          }
        ],

        images: [
          {file_id: 0, category: "", remarks: ""}
        ],

      };

      return updateData;
    },


    onChangeProcess(idx,data){

      console.log("onChangeProcess idx:" + idx,data)

      if (idx === -1){
        this.supplier.processGroups.push(data)
      } else {
        this.supplier.processGroups.splice(idx, 1, data)
      }

    },

    moveToSupplierPage(){
      let supplierId = this.supplierId
      this.$router.push({ name: 'supplier', params: { sup_cd: "" + supplierId } })

    },

    onDeleteImage(img){



      let index = this.supplier.imageMap.cat1.findIndex((v) => v.fileId === img.fileId);
      if (index >= 0){
        this.supplier.imageMap.cat1.splice(index, 1);
      }
      index = this.supplier.imageMap.cat2.findIndex((v) => v.fileId === img.fileId);
      if (index >= 0){
        this.supplier.imageMap.cat2.splice(index, 1);
      }
      index = this.supplier.imageMap.cat3.findIndex((v) => v.fileId === img.fileId);
      if (index >= 0){
        this.supplier.imageMap.cat3.splice(index, 1);
      }
  
    },

  },

}
</script>